import DescriptionList from './DescriptionList';
import Term from './Term';
import Description from './Description';

export * from './DescriptionList';
export { Term };
export { Description };
export default DescriptionList;
